// export const checkText = async (text, language) => {
//   const url = `${process.env.GATSBY_BASE_API_URL}/smart_corrector?text=${text}&lang_input=${language}&linguistic_level=gram&format=json`
//   try {
//     const res = await fetch(url)
//     console.log('RESPONSE', res)
//     return await res.json()
//   } catch (e) {
//     throw new Error(`Request failed. ${e}`)
//   }
// }

export const checkText = async (text, language) => {
  const url = `${process.env.GATSBY_BASE_API_URL}/smart_corrector`

  const data = new FormData()
  data.append('text', text)
  data.append('lang_input', language)
  data.append('linguistic_level', 'gram')
  data.append('format', 'json')

  try {
    const res = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'omit',
      body: data, //DON'T USE JSON FORMAT !!!
    })
    return await res.json()
  } catch (e) {
    throw new Error(`Request failed. ${e}`)
  }
}
